var map = {
	"./01_open_mushaf.svg": 40272,
	"./02_closed_quran_bookmark.svg": 40049,
	"./03_new_lesson_jadid.svg": 58719,
	"./04_review_yesterday_madi.svg": 23431,
	"./05_old_revision_sard.svg": 67951,
	"./06_hizb_marker.svg": 30232,
	"./07_juz_divider.svg": 36182,
	"./08_khatma_seal.svg": 3084,
	"./09_student.svg": 84784,
	"./10_teacher_sheikh.svg": 45570,
	"./11_family_parent.svg": 92277,
	"./12_director_moudir.svg": 32972,
	"./13_halaqa_circle.svg": 91717,
	"./14_profile_avatar.svg": 6328,
	"./15_hafiz_laurel.svg": 51846,
	"./16_class_roster.svg": 84417,
	"./17_star_rating.svg": 4356,
	"./18_trophy.svg": 42859,
	"./19_diploma_scroll.svg": 34304,
	"./20_medal.svg": 11195,
	"./21_crescent_badge.svg": 56180,
	"./22_laurel_wreath.svg": 14651,
	"./23_award_ribbon.svg": 63921,
	"./24_excellence_seal.svg": 74364,
	"./25_attendance_check.svg": 82157,
	"./26_calendar.svg": 47082,
	"./27_calendar_present.svg": 15373,
	"./28_calendar_absent.svg": 84764,
	"./29_bar_chart.svg": 21877,
	"./30_trend_chart.svg": 50449,
	"./31_donut_chart.svg": 57737,
	"./32_gauge.svg": 4158,
	"./33_clock.svg": 39124,
	"./34_hourglass.svg": 63899,
	"./35_month_calendar.svg": 99315,
	"./36_streak_flame.svg": 84855,
	"./37_mosque_small.svg": 14416,
	"./38_sunrise_fajr.svg": 93400,
	"./39_bell.svg": 77599,
	"./40_alarm.svg": 92239,
	"./41_microphone.svg": 70951,
	"./42_waveform.svg": 65983,
	"./43_lips_pronounce.svg": 61559,
	"./44_tajweed_letter.svg": 20585,
	"./45_headphones.svg": 35378,
	"./46_play.svg": 59012,
	"./47_repeat_loop.svg": 30541,
	"./48_big_check.svg": 38863,
	"./49_home_dashboard.svg": 29811,
	"./50_settings_gear.svg": 61332,
	"./51_search.svg": 82750,
	"./52_bell_filled.svg": 17091,
	"./53_logout_door.svg": 36749,
	"./54_add_plus.svg": 16785,
	"./55_edit_pencil.svg": 29106,
	"./56_filter.svg": 17169,
	"./57_mosque_detailed.svg": 49273,
	"./58_crescent_star.svg": 81191,
	"./59_lantern_fanous.svg": 14915,
	"./60_prayer_beads.svg": 95761,
	"./61_geo_star.svg": 51491,
	"./62_mihrab_arch.svg": 91784,
	"./63_date_palm.svg": 87770,
	"./64_rihal_stand.svg": 73557,
	"./65_new_wird_jadid.svg": 74705,
	"./66_yesterday_madi.svg": 73388,
	"./67_old_sard.svg": 64687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51295;